<template>
  <div class="item" @click="changeUrl">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DropItem",
  props: {
    to: {
      type: String,
      default: ""
    }
  },
  methods: {
    changeUrl() {
      if (this.to) {
        this.$router.push(this.to);
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.item
  width 100px
  height 35px
  line-height 35px
  text-align center
  color #fff
  &:hover
    background rgba(255, 255, 255, 0.2)
</style>
